export const ASSIGNMENT_DEFAULTS = {
  GENERAL_TIME_MARGIN: 20,
  EXTER_PROVIDER_TIME_MARGIN: 35,
  EXTRA_TOPPING_TIME_MARGIN: 12,
  MAX_DRIVER_WALK_TIME: 30,
  MAX_DRIVER_PUBLIC_TRANSPORT_TIME: 120,
  SWEEP_CAR_RADIUS: 100,
  SWEEP_CAR_MAX_ARRIVAL_TIME: 40,
} as const;

export const SECONDS_PER_MINUTE = 60;

export const DOM_SELECTORS = {
  TUI_HINTS_HOST: 'tui-hints-host',
  TUI_HINT: 'tui-hint',
  TUI_DROPDOWN: 'tui-dropdown',
  MODAL_CONTAINER: 'modal_add_assignament',
} as const;

export const DOM_STYLES = {
  HINTS_Z_INDEX: '2000',
  HINT_BACKGROUND: '#0F1113',
  HINT_COLOR: '#fff',
} as const;
